module.exports = __webpack_public_path__ + "static/media/Work-Day-Scheduler-screenshot.722a0648.png";